import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-678e86e2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "notas-credito-container" };
const _hoisted_2 = { class: "dashboard" };
const _hoisted_3 = { class: "notas-credito-content" };
const _hoisted_4 = { class: "page-header" };
const _hoisted_5 = /*#__PURE__*/ _createStaticVNode("<div class=\"header-left\" data-v-678e86e2><div class=\"header-icon\" data-v-678e86e2><i class=\"lni lni-reload\" data-v-678e86e2></i></div><div data-v-678e86e2><h1 class=\"page-title\" data-v-678e86e2>Notas de Crédito y Devoluciones</h1><p class=\"page-subtitle\" data-v-678e86e2>Gestión de saldos a favor, devoluciones e inyección de inventario</p></div></div>", 1);
const _hoisted_6 = { class: "header-right" };
const _hoisted_7 = { class: "filters-bar" };
const _hoisted_8 = { class: "search-wrapper" };
const _hoisted_9 = {
    key: 0,
    class: "results-badge"
};
const _hoisted_10 = { class: "table-card mt-4" };
const _hoisted_11 = { class: "data-table" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Código"),
        /*#__PURE__*/ _createElementVNode("th", null, "Cliente"),
        /*#__PURE__*/ _createElementVNode("th", null, "Fecha Emisión"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "Tipo"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "Estado"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "Total (USD)"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "Acciones")
    ])
], -1 /* HOISTED */));
const _hoisted_13 = { key: 0 };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "7",
    class: "empty-cell"
}, [
    /*#__PURE__*/ _createElementVNode("div", { class: "loading-state" }, [
        /*#__PURE__*/ _createElementVNode("div", { class: "spinner-ring" }),
        /*#__PURE__*/ _createElementVNode("p", null, "Cargando devoluciones...")
    ])
], -1 /* HOISTED */));
const _hoisted_15 = [
    _hoisted_14
];
const _hoisted_16 = { key: 1 };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "7",
    class: "empty-cell"
}, [
    /*#__PURE__*/ _createElementVNode("div", { class: "empty-state" }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-empty-file" }),
        /*#__PURE__*/ _createElementVNode("p", null, "No se encontraron notas de crédito.")
    ])
], -1 /* HOISTED */));
const _hoisted_18 = [
    _hoisted_17
];
const _hoisted_19 = { class: "code-badge" };
const _hoisted_20 = { class: "font-medium" };
const _hoisted_21 = { class: "text-muted" };
const _hoisted_22 = { class: "text-center" };
const _hoisted_23 = { class: "text-center" };
const _hoisted_24 = { class: "text-end" };
const _hoisted_25 = { class: "price-tag" };
const _hoisted_26 = { class: "text-center" };
const _hoisted_27 = { class: "actions-wrapper" };
const _hoisted_28 = ["onClick"];
const _hoisted_29 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Header = _resolveComponent("Header");
    const _component_Sidebar = _resolveComponent("Sidebar");
    const _component_PlusIcon = _resolveComponent("PlusIcon");
    const _component_SearchIcon = _resolveComponent("SearchIcon");
    const _component_EyeIcon = _resolveComponent("EyeIcon");
    const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Sidebar),
            _createElementVNode("div", _hoisted_3, [
                _createCommentVNode(" ── Page Header ── "),
                _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("div", _hoisted_6, [
                        (_ctx.canCreate)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn-primary-action",
                                onClick: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (_ctx.abrirModalCreacion && _ctx.abrirModalCreacion(...args)))
                            }, [
                                _createVNode(_component_PlusIcon, { size: 16 }),
                                _createTextVNode(" Emitir Nota ")
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _createCommentVNode(" ── Filters ── "),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_SearchIcon, {
                            size: 16,
                            class: "search-icon"
                        }),
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            placeholder: "Buscar por código de nota, cliente...",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.searchQuery) = $event)),
                            class: "search-input"
                        }, null, 512 /* NEED_PATCH */), [
                            [_vModelText, _ctx.searchQuery]
                        ])
                    ]),
                    (!_ctx.loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.filteredNotas.length) + " resultados ", 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                ]),
                _createCommentVNode(" ── Data Table ── "),
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("table", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("tbody", null, [
                            (_ctx.loading)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_13, _hoisted_15))
                                : (_ctx.filteredNotas.length === 0)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_16, _hoisted_18))
                                    : _createCommentVNode("v-if", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredNotas, (nota) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    key: nota.notaCreditoId,
                                    class: "table-row"
                                }, [
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", _hoisted_19, _toDisplayString(nota.codigoNota), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("div", _hoisted_20, _toDisplayString(nota.nombreCliente), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("td", _hoisted_21, _toDisplayString(new Date(nota.fechaEmision).toLocaleDateString('es-VE', { day: '2-digit', month: 'short', year: 'numeric' })), 1 /* TEXT */),
                                    _createElementVNode("td", _hoisted_22, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["type-pill", nota.tipoDevolucion === 'Cambio' ? 'change' : 'refund'])
                                        }, _toDisplayString(nota.tipoDevolucion), 3 /* TEXT, CLASS */)
                                    ]),
                                    _createElementVNode("td", _hoisted_23, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["estado-pill", _ctx.getEstadoClase(nota.estado)])
                                        }, _toDisplayString(_ctx.mapEstado(nota.estado)), 3 /* TEXT, CLASS */)
                                    ]),
                                    _createElementVNode("td", _hoisted_24, [
                                        _createElementVNode("span", _hoisted_25, "$" + _toDisplayString(nota.totalUsd.toFixed(2)), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("td", _hoisted_26, [
                                        _createElementVNode("div", _hoisted_27, [
                                            _createElementVNode("button", {
                                                class: "btn-action",
                                                title: "Ver Detalles",
                                                onClick: ($event) => (_ctx.verDetalles(nota))
                                            }, [
                                                _createVNode(_component_EyeIcon, { size: 16 })
                                            ], 8 /* PROPS */, _hoisted_28),
                                            (nota.estado === 'PendienteAlmacen' && _ctx.canConfirm)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    class: "btn-action confirm",
                                                    title: "Confirmar Reingreso Almacén",
                                                    onClick: ($event) => (_ctx.confirmarReingreso(nota))
                                                }, [
                                                    _createVNode(_component_CheckCircleIcon, { size: 16 })
                                                ], 8 /* PROPS */, _hoisted_29))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ])
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
